import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appLabelInflatorContainer]',
  standalone: false
})
export class LabelInflatorContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
